import { render, staticRenderFns } from "./ContractAttachmentsListItem.vue?vue&type=template&id=356d2653&"
import script from "./ContractAttachmentsListItem.vue?vue&type=script&lang=ts&"
export * from "./ContractAttachmentsListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports